export default {
  name: 'admin-svg'
};
